module.exports = __webpack_public_path__ + "img/RLC.d30b6ec9.svg";